// @flow

/**
 * Do not edit directly
 * Generated on Thu, 20 Feb 2020 17:25:54 GMT
 */

import { css } from 'styled-components';

export type Spacing = '0x' | '1x' | '2x' | '3x' | '4x' | '5x' | '6x' | '8x' | '12x' | '16x' | '24x';
export type FontWeight = 'regular' | 'semibold' | 'extrabold';
export type TextAlign = 'left' | 'center' | 'right';
export type TextColor =
  | 'primary'
  | 'primary_inverse'
  | 'secondary'
  | 'secondary_inverse'
  | 'tertiary'
  | 'tertiary_inverse'
  | 'disabled'
  | 'placeholder'
  | 'error'
  | 'price';
export type TextDecoration = 'none' | 'uppercase';
export type TextTransform = 'none' | 'underline';
export type HeadingSizes = '100' | '200' | '300' | '400' | '500' | '600';
export type ResponsiveHeadingSizes = '400' | '500' | '600';
export type ParagraphSizes = '100' | '200' | '300';
export type TextSizes = '100' | '200' | '300';

export const WEB_FALLBACK_FONT_FAMILIES = 'Avenir, Helvetica Neue, Helvetica, sans-serif';

export type HeadingStyles = { [HeadingSizes]: any };
export const headingStyles: HeadingStyles = {
  '100': css`
    font-family: Averta-Semibold, Avenir, Helvetica Neue, Helvetica, sans-serif;
    font-size: 13px;
    font-weight: 600 !important;
    line-height: 1.25;
    margin-bottom: 8px;
  `,
  '200': css`
    font-family: Averta-Semibold, Avenir, Helvetica Neue, Helvetica, sans-serif;
    font-size: 16px;
    font-weight: 600 !important;
    line-height: 1.25;
    margin-bottom: 12px;
  `,
  '300': css`
    font-family: Averta-Semibold, Avenir, Helvetica Neue, Helvetica, sans-serif;
    font-size: 20px;
    font-weight: 600 !important;
    line-height: 1.25;
    margin-bottom: 16px;
  `,
  '400': css`
    font-family: Averta-Extrabold, Avenir, Helvetica Neue, Helvetica, sans-serif;
    font-size: 26px;
    font-weight: 800 !important;
    line-height: 1.25;
    margin-bottom: 20px;
  `,
  '500': css`
    font-family: Averta-Extrabold, Avenir, Helvetica Neue, Helvetica, sans-serif;
    font-size: 32px;
    font-weight: 800 !important;
    line-height: 1.25;
    margin-bottom: 24px;
  `,
  '600': css`
    font-family: Averta-Extrabold, Avenir, Helvetica Neue, Helvetica, sans-serif;
    font-size: 38px;
    font-weight: 800 !important;
    line-height: 1.25;
    margin-bottom: 32px;
  `,
};
export type ResponsiveHeadingStyles = { [ResponsiveHeadingSizes]: any };
export const responsiveHeadingStyles: ResponsiveHeadingStyles = {
  '400': css`
    font-size: 32px;
  `,
  '500': css`
    font-size: 40px;
  `,
  '600': css`
    font-size: 48px;
  `,
};
export type ParagraphStyles = { [ParagraphSizes]: any };
export const paragraphStyles: ParagraphStyles = {
  '100': css`
    font-size: 13px;
    font-weight: 400 !important;
    line-height: 1.5;
    margin-bottom: 12px;
  `,
  '200': css`
    font-size: 16px;
    font-weight: 400 !important;
    line-height: 1.5;
    margin-bottom: 16px;
  `,
  '300': css`
    font-size: 20px;
    font-weight: 400 !important;
    line-height: 1.5;
    margin-bottom: 24px;
  `,
};

export type TextStyles = { [TextSizes]: any };
export const textStyles: TextStyles = {
  '100': css`
    font-size: 13px;
    font-weight: 400 !important;
    line-height: 1.25;
  `,
  '200': css`
    font-size: 16px;
    font-weight: 400 !important;
    line-height: 1.25;
  `,
  '300': css`
    font-size: 20px;
    font-weight: 400 !important;
    line-height: 1.2;
  `,
};

export type Theme = {
  space: { [Spacing]: string },
  fontWeight: { [FontWeight]: string | number },
  textAlign: { [TextAlign]: string },
  textColor: { [TextColor]: string },
  textDecoration: { [TextDecoration]: string },
  textTransform: { [TextTransform]: string },
};

const theme: Theme = {
  space: {
    '0x': '0px',
    '1x': '4px',
    '2x': '8px',
    '3x': '12px',
    '4x': '16px',
    '5x': '20px',
    '6x': '24px',
    '8x': '32px',
    '12x': '48px',
    '16x': '64px',
    '24x': '96px',
  },
  fontWeight: {
    regular: '400 !important',
    semibold: '600 !important',
    extrabold: '800 !important',
  },
  textAlign: {
    left: 'left',
    center: 'center',
    right: 'right',
  },
  textColor: {
    primary: '#1B1F23',
    primary_inverse: '#FFFFFF',
    secondary: '#40484F',
    secondary_inverse: '#F4F5F6',
    tertiary: '#66727C',
    tertiary_inverse: '#E8EBED',
    disabled: '#84909A',
    placeholder: '#66727C',
    error: '#E51A42',
    price: '#CC4E00',
  },
  textDecoration: {
    none: 'none',
    uppercase: 'uppercase',
  },
  textTransform: {
    none: 'none',
    underline: 'underline',
  },
};
export default theme;



// WEBPACK FOOTER //
// ../design-system/style-dictionary/build/es6/theme.js